<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">{{ 'receipts.ui.distintaContanti' | transloco }}</span>

  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    [attr.aria-label]="'receipts.ui.chiudi' | transloco"
    class="close-button"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  @if (exceedsMaxContanti) {
    <div class="cash-limit-error body-small" role="alert">
      <i class="fa-regular fa-circle-exclamation" aria-hidden="true"></i>
      <span>
        {{ 'receipts.ui.limiteContantiSuperatoMax' | transloco: { value0: (formatAmount(maxContanti!)) } }}
      </span>
    </div>
  }

  <span class="label-medium-emphasized">{{ 'receipts.ui.dettaglioBanconoteEMonetePerTaglio' | transloco }}</span>

  @for (row of banknoteRows; track row.importoTaglio) {
    <div class="input-row banknote-row">
      <div class="amount-column">
        <span class="body-medium">{{ 'receipts.ui.da' | transloco }}</span>
        <span class="body-medium-emphasized">{{ formatAmount(row.importoTaglio) }}</span>
      </div>

      <div class="quantity-column">
        <div class="quantity-input">
          <span class="body-medium">{{ 'receipts.ui.qTa2' | transloco }}</span>
          <div class="quantity-stepper">
            <button
              matButton="tonal"
              type="button"
              class="stepper-button"
              [disabled]="row.quantita === 0"
              [attr.aria-label]="(('receipts.ui.diminuisciQuantitaBanconoteDa' | transloco) + ' ') + row.importoTaglio + (' ' + ('receipts.ui.euro' | transloco))"
              (click)="decrementQuantity(row)"
            >
              <i class="fa-regular fa-minus" aria-hidden="true"></i>
            </button>

            <span class="body-medium-emphasized quantity-value">{{ row.quantita }}</span>

            <button
              matButton="tonal"
              type="button"
              class="stepper-button"
              [attr.aria-label]="(('receipts.ui.aumentaQuantitaBanconoteDa' | transloco) + ' ') + row.importoTaglio + (' ' + ('receipts.ui.euro' | transloco))"
              (click)="incrementQuantity(row)"
            >
              <i class="fa-regular fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="total-column">
          <span class="body-medium total-label">{{ 'receipts.ui.importo' | transloco }}</span>
          <mat-form-field class="total-field" appearance="outline" subscriptSizing="dynamic">
            <input matInput [value]="formatAmount(getRowTotal(row))" [attr.aria-label]="'receipts.ui.importo' | transloco" readonly />
          </mat-form-field>
          <span class="body-medium-emphasized mobile-row-total">
            {{ 'receipts.ui.tot' | transloco: { value0: (formatAmount(getRowTotal(row))) } }}
          </span>
        </div>
      </div>
    </div>
  }

  <div class="input-row coins-row">
    <div class="amount-column">
      <span class="body-medium-emphasized">{{ 'receipts.ui.monete' | transloco }}</span>
    </div>

    <div class="quantity-column">
      <div class="total-column">
        <span class="body-medium total-label">{{ 'receipts.ui.importo' | transloco }}</span>
        <mat-form-field class="total-field" appearance="outline" subscriptSizing="dynamic">
          <span matTextPrefix>€&nbsp;</span>
          <input
            matInput
            type="number"
            min="0"
            step="0.01"
            [attr.aria-label]="'receipts.ui.importoMonete' | transloco"
            [(ngModel)]="coinAmount"
          />
        </mat-form-field>
        <span class="body-medium-emphasized mobile-row-total">
          {{ 'receipts.ui.tot' | transloco: { value0: (formatAmount(coinAmount || 0)) } }}
        </span>
      </div>
    </div>
  </div>

  <span class="label-medium-emphasized">
    {{ 'receipts.ui.totaleCalcolato' | transloco: { value0: (formatAmount(calculatedTotal)) } }}
  </span>

</mat-dialog-content>

<mat-dialog-actions class="cash-actions">
  <button matButton="outlined" mat-dialog-close type="button">{{ 'receipts.ui.annulla' | transloco }}</button>
  <button
    matButton="filled"
    type="button"
    [disabled]="exceedsMaxContanti"
    [mat-dialog-close]="result"
  >
    {{ 'receipts.ui.confermaImporto' | transloco }}
  </button>
</mat-dialog-actions>
